import { ensureNavigatorStyles } from '../../styles/lazy.js';

let adminPromise;
let navigatorPromise;

export function loadAdminRuntime() {
  if (!adminPromise) {
    adminPromise = Promise.all([
      import('../admin/users-ai.runtime.js'),
      import('../admin/operations-parser.runtime.js'),
      import('../admin/reports.runtime.js'),
    ]).then(([users, operations, reports]) => {
      users.initUsersAiRuntime?.();
      operations.initOperationsParserRuntime?.();
      reports.initReportsRuntime?.();
      return { ...users, ...operations, ...reports };
    }).catch((error) => {
      adminPromise = undefined;
      throw error;
    });
  }
  return adminPromise;
}

export function loadNavigatorRuntime() {
  if (!navigatorPromise) {
    navigatorPromise = Promise.all([
      ensureNavigatorStyles(),
      import('../../features/navigator/runtime.js'),
    ]).then(([, navigator]) => navigator).catch((error) => {
      navigatorPromise = undefined;
      throw error;
    });
  }
  return navigatorPromise;
}

export function preloadView(view) {
  if (view === 'admin') return loadAdminRuntime().then(() => undefined);
  if (view === 'navigator') return loadNavigatorRuntime().then(() => undefined);
  return Promise.resolve();
}
